<template>
  <div class="connect-with-us connect-with-us--sticky">
    <div class="connect-with-us__title">{{ connectWithUsText }}</div>
    <ul class="social-icons">
      <li class="social-icon">
        <a :href="facebookUrl" target="_blank">
          <i class="fab fa-facebook-f" />
        </a>
      </li>
      <li class="social-icon">
        <a :href="twitterUrl" target="_blank">
          <i class="fab fa-twitter" />
        </a>
      </li>
      <li class="social-icon">
        <a :href="instagramUrl" target="_blank">
          <i class="fab fa-instagram" />
        </a>
      </li>
      <li class="social-icon">
        <a href="https://www.youtube.com/user/bandwagoners" target="_blank">
          <i class="fab fa-youtube" />
        </a>
      </li>
    </ul>
    <hr>
    <div class="connect-with-us__title">
      {{ connectText }}
    </div>

    <NewsletterForm
      :locale="locale"
      :country-newsletter-id="countryNewsletterId"
    />

    <fw-storyblock
      channel="bandwagon"
      playlist="g208r5"
      autoplay="true"
      height="400px"
      branding="false"
    ></fw-storyblock>
  </div>
</template>

<script>
import NewsletterForm from '../shared/NewsletterForm.vue';

export default {
  components: {
    NewsletterForm,
  },

  props: {
    locale: {
      type: String,
      default: 'en',
    },
    country: {
      type: String,
      default: 'SG',
    },
    countryNewsletterId: { type: String, default: 'c04c8e2b7e' },
  },

  computed: {
    newsletterId() { return (this.country === 'PH' ? '6f817f9c18' : 'c04c8e2b7e'); },
    twitterUrl() { return (this.country === 'PH' ? '//twitter.com/bandwagonph' : '//twitter.com/bandwagonasia'); },
    facebookUrl() { return (this.country === 'PH' ? '//www.facebook.com/bandwagonph' : '//www.facebook.com/profile.php?id=100063606310658'); },
    instagramUrl() { return (this.country === 'PH' ? '//instagram.com/bandwagon.ph' : '//instagram.com/bandwagonasia'); },
    connectText() { return (this.locale === 'en' ? 'Ride first class on the Bandwagon with the latest gig news!' : '通往最新现场演出的路上，别忘了搭上Bandwagon的头等舱!'); },
    connectWithUsText() { return (this.locale === 'en' ? 'Connect with Us' : '与我们互动'); },
  },
};
</script>
